import styled, { css } from 'styled-components';
import { Colors } from '~/config/Colors';

export const InputText = styled.div`
  width: 100%;

  /* ${props =>
    props.disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `} */
`;

export const Label = styled.label`
  margin-bottom: 4px;

  color: ${Colors.text_Color_1};
  font-size: 0.75em;
  font-weight: 500;
  line-height: 10px;
`;

export const InputContainer = styled.div`
  position: relative;
`;

export const Select = styled.select`
  width: 100%;
  height: 38px;
  padding-inline: 18px;

  background-color: ${Colors.Color23};
  border: 1px solid rgb(255 255 255 / 0.15);
  border-radius: 8px;

  color: ${Colors.text_Color_1};
  font-size: 0.75em;
  font-weight: 300;

  transition: border, background-color 300ms ease-in-out;

  /* &:read-only {
    background-color: ${Colors.Input_Color_2};
  } */
`;

export const Option = styled.option`
  background: ${Colors.Color23 || '#23272f'};
  color: ${Colors.text_Color_1};
`;

export const Error = styled.p`
  margin-top: 0.3rem;
  color: ${Colors.ftColor6};
  font-size: 0.65em;
  font-weight: 300;
`;
